import React from 'react';
import styled from 'styled-components';
import {
  DialogBox,
  VisitContents,
  VisitHeader,
} from '@mummssoftware/common-ui';
import { formatLocDateMMDDYY } from '@mummssoftware/utils/formatters';
import { dateKeyToLocalDate } from '../data';

export type EventModalData = {
  visit: mumms.pimreaderVisit;
  roleGroupName: string;
  frequencyLabel: string;
  /**
   * Non-padded YYYY-M-D date key (from getFullCalendarDateKey) — avoids
   * browser-local-time misinterpretation of FullCalendar's fake-UTC dates.
   */
  dateKey: string;
};

type EventModalProps = {
  modalOpen: EventModalData | null;
  closeModal: () => void;
};

const getModalTitle = ({
  roleGroupName,
  frequencyLabel,
  dateKey,
}: EventModalData): string => {
  const parts = [
    roleGroupName,
    frequencyLabel.trim(),
    formatLocDateMMDDYY(dateKeyToLocalDate(dateKey)),
  ].filter(Boolean);
  return parts.join(' · ');
};

const VisitBlock = styled.div`
  border: 1px solid ${(props) => props.theme.palette.divider};
  margin-bottom: 5px;
  padding-top: 15px;
`;

export const EventModal = ({ modalOpen, closeModal }: EventModalProps) => {
  if (!modalOpen) {
    return null;
  }

  return (
    <DialogBox
      open
      maxWidth="lg"
      handleClick={closeModal}
      title={getModalTitle(modalOpen)}
    >
      <div style={{ minWidth: '50vw' }}>
        <VisitBlock>
          <VisitHeader dto={modalOpen.visit} />
          <VisitContents dto={modalOpen.visit} editing={false} />
        </VisitBlock>
      </div>
    </DialogBox>
  );
};
